import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { ArrowRecurringIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import TimezonePicker from 'components/availability/form/timezone_picker';
import { CustomHoursView } from 'components/event_type_edit';
const containerIsTabletUpCss = "c1ih9pda";
const containerCss = "c1kmienq";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const formContainerIsTabletUpCss = "fr3xc50";
const formContainerCss = "fpfdlev";
const FormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(formContainerCss, {
    [formContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headerContainerCss = "h1npyued";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, props.className)} />;
});
const iconHeaderContainerCss = "iakr33l";
const IconHeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconHeaderContainerCss, props.className)} />;
});
export const WeeklyHoursSection = () => {
  const isTabletUp = useDeviceType('isTabletUp');
  const isSmallPhone = useDeviceType('isSmallPhone');
  const [{
    value: days
  }, _, {
    setValue: setDays
  }] = useFormField({
    name: 'days'
  });
  const [{
    value: timezone
  }, _meta3, {
    setValue: setTimezone
  }] = useFormField({
    name: 'timezone'
  });
  const setWdayIntervals = (wday, newIntervals) => {
    const newDay = {
      ...days,
      [wday]: newIntervals
    };
    setDays(newDay);
  };
  const cloneWeekdayAvailability = (weekday, targetWeekdays) => {
    const newRules = targetWeekdays.reduce((rules, targetWeekday) => ({
      ...rules,
      [targetWeekday]: rules[weekday] || []
    }), days);
    setDays(newRules);
  };
  return <Container>
      <HeaderContainer>
        <IconHeaderContainer>
          <ArrowRecurringIcon spacingRight="8" />
          <BodyText size={isTabletUp ? 'large' : 'small'} weight={isTabletUp ? 'bold' : 'normal'}>
            {I18n.t('publisher.availability.schedules.weekly_hours')}
          </BodyText>
        </IconHeaderContainer>
        <BodyText size={isTabletUp ? 'small' : 'x-small'} color="muted">
          {I18n.t('publisher.availability_page.default_schedule.weekly_hours.subheader')}
        </BodyText>
      </HeaderContainer>
      <FormContainer>
        <CustomHoursView cloneWeekdayAvailability={cloneWeekdayAvailability} days={days} isExtraSmallPhone={isSmallPhone} setWdayIntervals={setWdayIntervals} redesignStyling allowCopy allowCopyUnavailable={false} />
        <TimezonePicker aria-labelledby="timezone-title" timezone={timezone} onSelectTimezone={setTimezone} alternateStyling />
      </FormContainer>
    </Container>;
};

require("./weekly_hours_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./weekly_hours_section.js");